import { render } from "./DriverRecruit.vue?vue&type=template&id=0c5c693d&scoped=true"
import script from "./DriverRecruit.vue?vue&type=script&lang=js"
export * from "./DriverRecruit.vue?vue&type=script&lang=js"

import "./DriverRecruit.vue?vue&type=style&index=0&id=0c5c693d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5c693d"]])

export default __exports__